export default "__VITE_ASSET__BqAHry95__"